import creatorFeedbackClient, { FeedbackPermissions } from '@modules/clients/creatorFeedbackClient';
import { useRobloxAuthentication } from '@rbx/auth';
import { useEffect, useMemo, useState } from 'react';

const defaultPermissionsData: FeedbackPermissions = {
  isDocsFeedbackAllowed: true,
  isPublicDevForumFeedbackAllowed: false,
  descriptionLength: { min: 30, max: 3000 },
  titleLength: { min: 10, max: 150 },
};

let config: FeedbackPermissions;

const useLoadedFeedbackConfig = () => {
  const { isFetched: isAuthLoaded, user: authenticatedUser } = useRobloxAuthentication();
  const isNotLoggedIn = useMemo(
    () => isAuthLoaded && !authenticatedUser?.id,
    [isAuthLoaded, authenticatedUser],
  );
  const [data, setData] = useState<FeedbackPermissions>(defaultPermissionsData);
  const [hasFeedbackServiceError, setHasFeedbackServiceError] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const loadData = async () => {
    try {
      if (config) {
        setData(config);
        return;
      }
      const resp = await creatorFeedbackClient.getConfig();
      config = resp;
      setData(resp);
    } catch {
      // feedback system network error
      setHasFeedbackServiceError(true);
    } finally {
      setIsReady(true);
    }
  };
  useEffect(() => {
    if (isNotLoggedIn) {
      setIsReady(true);
    }
    if (authenticatedUser?.id) {
      loadData();
    }
  }, [authenticatedUser?.id, isNotLoggedIn]);
  return { isReady, hasFeedbackServiceError, ...data };
};

export default useLoadedFeedbackConfig;
